export const EngineType = [
  { value: 1, label: 'playsmart' },
  { value: 2, label: 'phaser(qc)' },
  { value: 3, label: 'layabox' },
  { value: 4, label: 'egret' },
  { value: 5, label: 'three.js' },
  { value: 6, label: 'mw_endcard' },
  { value: 7, label: 'playsmart(new)' },
  { value: 8, label: 'Cocos Creator' },
  { value: 9, label: 'Cocos2dx' },
  { value: 10, label: 'phaser' },
  { value: 11, label: 'pixi' },
  { value: 99, label: '未知引擎' },
]
